import * as React from "react";
import { Component } from "react";

import { Toolbar } from "react-md";
import "./Header.css";
import TopNav from "./TopNav";

class App extends Component {
  render() {
    return (
      <Toolbar colored title="Диванные критики">
        <TopNav/>
      </Toolbar>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/layout/header/Header.tsx